/** Roles from PRD §8. Scoped per entity and, for field roles, per chantier. */
export const ROLES = [
    "group_admin",
    "entity_admin",
    "warehouse_keeper",
    "chef_chantier",
    "employee",
    "subcontractor",
    "subenterprise_manager",
    "viewer",
];
export const PRICE_READER_ROLES = [
    "group_admin",
    "entity_admin",
    "warehouse_keeper",
    "subenterprise_manager",
];
export const ADMIN_ROLES = [
    "group_admin",
    "entity_admin",
    "subenterprise_manager",
];
export const FIELD_ROLES = [
    "chef_chantier",
    "employee",
    "subcontractor",
];
const ROLE_PRIORITY = {
    group_admin: 0,
    entity_admin: 1,
    subenterprise_manager: 2,
    warehouse_keeper: 3,
    chef_chantier: 4,
    employee: 5,
    subcontractor: 6,
    viewer: 7,
};
/** Highest-privilege role from a user's grants (used to pick the primary shell and default view). */
export function primaryRole(roles) {
    if (!roles.length)
        return "viewer";
    const sorted = [...roles].sort((a, b) => (ROLE_PRIORITY[a.role] ?? 99) - (ROLE_PRIORITY[b.role] ?? 99));
    return (ROLES.includes(sorted[0].role) ? sorted[0].role : "viewer");
}
export function canReadPrices(role) {
    return PRICE_READER_ROLES.includes(role);
}
export function canReadAdminPrices(role) {
    return ADMIN_ROLES.includes(role);
}
/** Which adaptive shell a role gets on a phone-sized viewport (build plan §1.3). */
export function mobileShellFor(role) {
    return role === "group_admin" ||
        role === "entity_admin" ||
        role === "subenterprise_manager" ||
        role === "warehouse_keeper" ||
        role === "viewer"
        ? "mobile_admin"
        : "mobile_field";
}
//# sourceMappingURL=roles.js.map